




























































import { Vue, Component, Inject } from "vue-property-decorator";
import {
  IBrandsProvider,
  IBrandsProviderMethods
} from "@/models/providers/brands";

@Component({
  components: {
    "brand-grid-item": () =>
      import("@/components/app/admin/settings/brands/brandGridItem.vue")
  }
})
export default class BrandsGrid extends Vue {
  // Inject

  @Inject({ from: "brandsProviderData" })
  public readonly $brandsProvider!: () => IBrandsProvider;

  @Inject({ from: "brandsProviderMethods" })
  public readonly $brandsMethods!: IBrandsProviderMethods;

  // Computed

  public get $brandsData() {
    return this.$brandsProvider();
  }

  public get skeletonSize() {
    return this.$brandsData.table.total || this.$store.getters["ui/isMobile"]
      ? 2
      : 6;
  }
}
